// Placeholder de marca mientras image_url sea null (futuro: generación IA).
interface Props {
    src?: string | null;
    alt?: string;
    className?: string;
    }
    
    export default function ImagePlaceholder({ src, alt = "", className = "" }: Props) {
    if (src) {
      return <img src={src} alt={alt} className={`object-cover ${className}`} />;
    }
    // Placeholder genérico Radar — sustituible por asset de Figma.
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-gray-200 to-gray-300 ${className}`}
        aria-label="Radar placeholder"
      >
        <span className="text-xl font-bold text-gray-400">Radar</span>
      </div>
    );
    }